import { getAccount } from "../api/accountApi"
import UserDataApi from "../api/UserDataApi"
import { getSessionStorage, removeSessionStorage, setSessionStorage } from "./StorageUtil"

export const TOKEN_SO_KEY: string = "id_token"
export const ACCOUNT_SO_KEY: string = "account"
export const USER_ID_SO_KEY: string = "user-data-id"
export const COMPANY_ID_SO_KEY: string = "company-id"
export const USER_SO_KEY: string = "user-data"
export const GATEWAY_TOKEN: string = "jhi-authenticationToken"

export async function checkSOData () {
  if (getSessionStorage(TOKEN_SO_KEY) === null || getSessionStorage(ACCOUNT_SO_KEY) !== null)
    return

  const account = await getAccount()
  setSessionStorage(ACCOUNT_SO_KEY, account.data)
  const userData = await UserDataApi.filterByEmail(account.data.email)
  setSessionStorage(USER_SO_KEY, userData.data[0])
  setSessionStorage(USER_ID_SO_KEY, userData.data[0].id)
  if(userData.data[0].company && userData.data[0].company.id){
    setSessionStorage(COMPANY_ID_SO_KEY, userData.data[0].company?.id)
  }
 
} 

export const cleanSOData = () => {
  removeSessionStorage(TOKEN_SO_KEY)
  removeSessionStorage(GATEWAY_TOKEN)
  removeSessionStorage(ACCOUNT_SO_KEY)
  removeSessionStorage(USER_ID_SO_KEY)
  removeSessionStorage(COMPANY_ID_SO_KEY)
  removeSessionStorage(USER_SO_KEY)
} 